<template>
  <!--Loading dialog-->
  <v-dialog
    v-model="loading"
    :retain-focus="false"
    hide-overlay
    persistent
    width="300"
    style="z-index: 30000;"
  >
    <v-card color="light-blue darken-3" dark style="z-index: 30000;">
      <v-card-text>
        Please stand by
        <v-progress-linear
          indeterminate
          color="white"
          class="mb-0"
        ></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    loading: {
      type: Boolean,
      required: true
    }
  }
};
</script>
